import { Ref, WatchStopHandle } from 'vue';

export default function useTrafficSignalLayer(
  mapInstance: LooseObject,
  layerInfo: Ref<MapLayer<TrafficSignalLayerConfig>>,
) {
  if (!layerInfo.value || !layerInfo.value.config || !TMap.traffic?.TrafficSignal) return;

  const { position, state } = layerInfo.value.config;

  let unwatchList: WatchStopHandle[] | null = [];

  let layer = new TMap.traffic.TrafficSignal({
    map: mapInstance,
    position: new TMap.LatLng(position.lat, position.lng),
  });

  Array.isArray(state) && layer && layer.setState(state);

  unwatchList.push(watch(() => layerInfo.value.config.position, () => {
    layer?.destroy();
    layer = null;
    useTrafficSignalLayer(mapInstance, layerInfo);
  }, { deep: true }));

  unwatchList.push(watch(() => layerInfo.value.config.state, (newVal) => {
    try {
      Array.isArray(newVal) && layer && layer.setState(newVal);
    } catch (error) {
      layer.setState([]);
    }
  }, { deep: true }));

  layer.unmount = (): void => {
    layer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return layer;
}
